// src/theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  direction: "rtl",
  config: {
    initialColorMode: 'light',
    useSystemColorMode: true,
  },
  breakpoints: {
    sm: "30em",    // 480px
    md: "48em",    // 768px
    lg: "62em",    // 992px
    xl: "80em",    // 1280px
    "2xl": "96em", // 1536px
  },
  fonts: {
    heading: "Alef, 'Heebo', sans-serif",
    body: "Alef, 'Heebo', sans-serif",
  },
  colors: {
    brand: {
      50: '#e6fffa',
      100: '#b2f5ea',
      200: '#81e6d9',
      300: '#4fd1c7',
      400: '#38b2ac',
      500: '#319795',
      600: '#2c7a7b',
      700: '#285e61',
      800: '#234e52',
      900: '#1d4044',
    }
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'teal',
      },
      variants: {
        solid: {
          borderRadius: 'md',
          fontWeight: 'semibold',
        },
        outline: {
          borderRadius: 'md',
          fontWeight: 'semibold',
        }
      }
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: 'xl',
          overflow: 'hidden',
        }
      }
    },
    Alert: {
      baseStyle: {
        container: {
          borderRadius: 'lg',
        }
      }
    }
  },
  styles: {
    global: (props) => ({
      body: {
        color: props.colorMode === 'dark' ? 'white' : 'gray.800',
        bg: props.colorMode === 'dark' ? 'gray.900' : 'gray.50',
      },
      // אנימציות מותאמות אישית
      '.animate-pulse': {
        animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
      },
      '.animate-bounce': {
        animation: 'bounce 1s infinite',
      },
      '.animate-spin': {
        animation: 'spin 1s linear infinite',
      },
      '@keyframes pulse': {
        '0%, 100%': {
          opacity: 1,
        },
        '50%': {
          opacity: 0.5,
        },
      },
      '@keyframes bounce': {
        '0%, 100%': {
          transform: 'translateY(-25%)',
          animationTimingFunction: 'cubic-bezier(0.8, 0, 1, 1)',
        },
        '50%': {
          transform: 'translateY(0)',
          animationTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
        },
      },
      '@keyframes spin': {
        to: {
          transform: 'rotate(360deg)',
        },
      },
    }),
  },
});

export default theme;